export type JoystickVector={x:number;y:number;distance:number};

export function calculateJoystick(
  pointerX:number,
  pointerY:number,
  centerX:number,
  centerY:number,
  radius:number,
  deadZone=.16,
):JoystickVector{
  const dx=pointerX-centerX,dy=pointerY-centerY;
  const rawDistance=Math.hypot(dx,dy);
  if(radius<=0||rawDistance===0)return{x:0,y:0,distance:0};
  const clampedDistance=Math.min(rawDistance,radius);
  const directionX=dx/rawDistance,directionY=dy/rawDistance;
  const normalizedDistance=clampedDistance/radius;
  if(normalizedDistance<=deadZone)return{x:0,y:0,distance:normalizedDistance};
  const magnitude=(normalizedDistance-deadZone)/(1-deadZone);
  return{x:directionX*magnitude,y:directionY*magnitude,distance:normalizedDistance};
}

export class VirtualInputState{
  horizontal=0;
  vertical=0;
  grip=false;
  private jumpQueued=false;
  private gripOriginY=0;
  private gripSwipeArmed=false;

  setJoystick(vector:JoystickVector){this.horizontal=vector.x;this.vertical=vector.y}
  pressJump(){this.jumpQueued=true}
  consumeJump(){const pressed=this.jumpQueued;this.jumpQueued=false;return pressed}
  beginGrip(pointerY:number){this.grip=true;this.gripOriginY=pointerY;this.gripSwipeArmed=true}
  moveGrip(pointerY:number,threshold=40){
    if(!this.grip)return false;
    const upward=this.gripOriginY-pointerY;
    if(!this.gripSwipeArmed){if(upward<=threshold*.45)this.gripSwipeArmed=true;return false}
    if(upward<threshold)return false;
    this.gripSwipeArmed=false;this.pressJump();return true;
  }
  endGrip(){this.grip=false;this.gripSwipeArmed=false}
  reset(){this.horizontal=0;this.vertical=0;this.endGrip();this.jumpQueued=false}
}
